import configJson from "./env.json";

interface EnvConfig {
  apiUrl: string;
  websiteUrl: string;
  version: string;
}

export const config = configJson as EnvConfig;
